import marca from '../nucleo/marca.generated.json';

/** Usar este componente en toda cabecera: la URL cambia con la fuente vectorial. */
export function Marca() {
  return <img src={marca.logo} alt="EnCancha" width="180" height="36" className="block h-9 w-[180px] object-contain" fetchPriority="high" />;
}
